import { confirmationPopupState } from "Components/common/confirmationPopup";

// Previously prompted the user to install the Salesgear LinkedIn Connector
// extension. The connect flow is now routed to support instead, so we surface
// an "unavailable" message with a Chat with support CTA.
const pluginNotInstalled = () => {
  confirmationPopupState.setPopupValues({
    content: `Connecting LinkedIn is currently unavailable. Reach out to <a href="mailto:support@salesgear.io" target="_blank" rel="noopener noreferrer">support@salesgear.io</a> for more details.`,
    actionBtnText: "Chat with support",
    cancelBtnText: "Close",
    // id="my_custom_link" hooks into Intercom's custom_launcher_selector so
    // clicking the button opens the support chat.
    id: "my_custom_link",
    callback: () => confirmationPopupState.setShowPopup(false)
  });
  confirmationPopupState.setShowPopup(true);
};

export { pluginNotInstalled };
export default pluginNotInstalled;
